import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="16.32" height="26.429" viewBox="0 0 16.32 26.429">
        <path d="M12.885,31.949,22.972,21.84,12.885,11.73,15.99,8.625,29.2,21.84,15.99,35.054Z" transform="translate(-12.885 -8.625)"/>
    </svg>

}
